export const environment = {
  clientId: 'membership-spa'
};
